import { render, staticRenderFns } from "./MainColumn.vue?vue&type=template&id=60b0437c&"
import script from "./MainColumn.vue?vue&type=script&lang=js&"
export * from "./MainColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b0437c')) {
      api.createRecord('60b0437c', component.options)
    } else {
      api.reload('60b0437c', component.options)
    }
    module.hot.accept("./MainColumn.vue?vue&type=template&id=60b0437c&", function () {
      api.rerender('60b0437c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/MainColumn.vue"
export default component.exports